const book = { 
	state: {
		id: null,
		detail: null,
		chapterId: null
	},
	mutations: {
		'SET_BOOKID': (state, id) => {
        	state.id = id
        },
		'SET_DETAIL': (state, detail) => {
        	state.detail = detail
        },
		'SET_CHAPTERID': (state, chapterId) => {
        	state.chapterId = chapterId
        }
	}
}

export default book


// WEBPACK FOOTER //
// ./src/store/modules/book.js